'use client';
import React, { FC } from 'react';
import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import {
  ArrowsLeft,
  ArrowsRight,
  // CircleL,
  CircleS,
  CircleXl,
  LineV1,
  LineV2,
  Snow,
  SnowflakeLeft,
  SnowflakeRight,
} from '@/public/images/layout/layout';
import style from './MainSectionLayout.module.scss';

interface IProps {
  children: React.ReactNode;
  variant: 'primary' | 'secondary';
  layout: 'snow' | 'line' | 'sline' | 'arrows' | 'circle' | 'snowCircle';
}

export const MainSectionLayout: FC<IProps> = ({ children, layout }) => {
  const renderVariant = () => {
    if (layout === 'snow') {
      return (
        <div className={style.snowLayout}>
          <div className={style.itemLeft}>
            <SnowflakeLeft />
          </div>
          <div className={style.itemRight}>
            <SnowflakeRight />
          </div>
        </div>
      );
    }
    if (layout === 'line') {
      return (
        <div className={style.lineLayout}>
          <LineV1 />
        </div>
      );
    }
    if (layout === 'sline') {
      return (
        <div className={style.lineLayoutV2}>
          <LineV2 />
        </div>
      );
    }
    if (layout === 'arrows') {
      return (
        <div className={style.arrowsLayout}>
          <div className={style.arrowLeft}>
            <ArrowsLeft />
          </div>
          <div className={style.arrowRight}>
            <ArrowsRight />
          </div>
        </div>
      );
    }
    if (layout === 'circle') {
      return (
        <div className={style.arrowsLayout}>
          <div className={style.arrowLeft}>
            <CircleXl />
          </div>
          <div className={style.arrowRight}>
            <CircleS />
          </div>
        </div>
      );
    }
    if (layout === 'snowCircle') {
      return (
        <div className={style.arrowsLayout}>
          <div className={style.arrowLeft}>
            <CircleXl />
          </div>
          <div className={style.arrowRight}>
            <Snow />
          </div>
        </div>
      );
    }
  };

  return (
    <Section variant="primary">
      {renderVariant()}
      <Container>
        <div>{children}</div>
      </Container>
    </Section>
  );
};
